import {documentToReactComponents} from '@contentful/rich-text-react-renderer'
import {
    Box,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import React from 'react'
import {styleConfigChakraKeys} from '../../../../constants'
import {blogOptions} from './Options'

export default function BlogDetailRichText({pageContent}) {
    const styles = useMultiStyleConfig(styleConfigChakraKeys.blogDetailRichText)
    const {json, links} = pageContent.content

    return (
        <Box {...styles.richContent} sx={styles.richContentSx}>
            <Box as="h2" {...styles.contentHeading}>
                {pageContent?.heading}
            </Box>
            {documentToReactComponents(json, blogOptions(links))}
        </Box>
    )
}

BlogDetailRichText.propTypes = {
    pageContent: PropTypes.object
}
